import { useTranslation } from "react-i18next";

import { IconClipboardPlus } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";

import { useLanguage } from "@hooks/useLanguage";
import { useProcurement } from "@hooks/inventory/procurements/useProcurement";

import { ProductType } from "@type/inventory/procurements";

const ProductDetailsPageHeader = ({ productDetails }: ProductType) => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { procurementsState } = useProcurement();
  const { getSingleData } = procurementsState;

  const { name } = productDetails || {};

  const breadcrumbs = [
    {
      icon: <IconClipboardPlus fill="dark" size="20" />,
    },
    {
      label: t("SIDEBAR.INVENTORY.REGISTER.PROCUREMENTS"),
      link: ROUTES.INVENTORY.PROCUREMENTS,
    },
    {
      label: language === "bn" ? getSingleData?.nameBn : getSingleData?.nameEn,
      link: `${ROUTES.INVENTORY.PROCUREMENTS}/${getSingleData?.id}`,
    },
    {
      label: productDetails
        ? language === "bn"
          ? name?.nameBn
          : name?.nameEn
        : t("PROCUREMENTS_DETAILS.PRODUCT_DETAILS.HEADING"),
    },
  ];

  const headerText = {
    header: ` ${
      productDetails
        ? language === "bn"
          ? name?.nameBn
          : name?.nameEn
        : t("PROCUREMENTS_DETAILS.PRODUCT_DETAILS.HEADING")
    }`,
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
};

export default ProductDetailsPageHeader;
